<template>
  <div class="app-content">
    <div class="wrapper" v-if="recharge">
      <div class="auth-tip-box" v-if="isAuth == false">
        <img src="../../../../assets/img/official/home_icon_announcement.png" alt="">
        <span class="tip-span">您还未授权公众号，请先</span>
        <span class="to-auth" @click="auth">授权公众号</span>
        <img src="../../../../assets/img/official/home_btn_arrow_red.png" alt="">
      </div>
      <div class="wechat-wrap">
        <div class="top-part">
          <div>
            <span class="part-title">套餐类型：</span>
            <span class="part-content">{{ basicInfo.name }}</span>
          </div>
          <div>
            <span class="part-title">有效期：</span>
            <span class="part-content">{{ basicInfo.effectTime }} {{ getTimeTip() }}</span>
          </div>
          <div>
            <span class="part-title">剩余可提现（元）：</span>
            <span class="part-content">{{ basicInfo.settleBalance ? basicInfo.settleBalance : 0 }}</span>
          </div>
          <div class="withdraw-box">
            <span class="withdraw-btn" @click="goWithdraw()">提现</span>
          </div>
          <div class="figure-box">
            <img src="../../../../assets/img/official/home_img_figure.png" alt="">
          </div>
        </div>
        <div class="data-wrap">
          <el-row>
            <el-col :span="6">
              <div class="data-card">
                <div class="card-head background-eef9ff">
                  <div>本月新增会员数</div>
                  <div>{{ statisticsInfo.userCountMonth }}</div>
                </div>
                <div class="card-content">
                  <div><span class="card-num today-member">{{ statisticsInfo.userCountToday }}</span>个</div>
                  <div class="content-desc">
                    <span>今日新增会员</span>
                    <span class="float-num">{{ increaseUser >= 0 ? '较昨日上升' : '较昨日下降' }}<span>{{ Math.abs(increaseUser)
                    }}</span>个</span>
                    <img src="../../../../assets/img/official/home_sign_arrow_upward.png" v-if="increaseUser > 0" />
                    <img src="../../../../assets/img/official/home_sign_arrow_down.png" v-else />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="data-card margin-left-16">
                <div class="card-head background-fff5ed">
                  <div>本月新增订单数</div>
                  <div>{{ statisticsInfo.orderCountMonth }}</div>
                </div>
                <div class="card-content">
                  <div><span class="card-num today-member">{{ statisticsInfo.orderCountToday }}</span>件</div>
                  <div class="content-desc">
                    <span>今日新增订单</span>
                    <span class="float-num">{{ increaseOrder >= 0 ? '较昨日上升' : '较昨日下降' }}<span>{{ Math.abs(increaseOrder)
                    }}</span></span>
                    <img src="../../../../assets/img/official/home_sign_arrow_upward.png" v-if="increaseOrder > 0" />
                    <img src="../../../../assets/img/official/home_sign_arrow_down.png" v-else />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="data-card margin-left-16">
                <div class="card-head background-ebfbf9">
                  <div>本月结算收入</div>
                  <div>{{ statisticsInfo.commissionMonth }}</div>
                </div>
                <div class="card-content">
                  <div><span class="card-num today-member">{{ statisticsInfo.commissionToday }}</span>元</div>
                  <div class="content-desc">
                    <span>今日佣金</span>
                    <span class="float-num">{{ increaseCommission >= 0 ? '较昨日上升' : '较昨日下降' }}<span>{{
                      Math.abs(increaseCommission).toFixed(2) }}</span></span>
                    <img src="../../../../assets/img/official/home_sign_arrow_upward.png" v-if="increaseCommission > 0" />
                    <img src="../../../../assets/img/official/home_sign_arrow_down.png" v-else />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="data-card margin-left-16">
                <div class="card-head background-f5f3fe">
                  <div>本月推广利润</div>
                  <div>{{ statisticsInfo.profitMonth }}</div>
                </div>
                <div class="card-content">
                  <div><span class="card-num today-member">{{ statisticsInfo.profitToday }}</span>元</div>
                  <div class="content-desc">
                    <span>今日利润</span>
                    <span class="float-num">{{ increaseProfit >= 0 ? '较昨日上升' : '较昨日下降' }}<span>{{
                      Math.abs(increaseProfit).toFixed(2) }}</span></span>
                    <img src="../../../../assets/img/official/home_sign_arrow_upward.png" v-if="increaseProfit > 0" />
                    <img src="../../../../assets/img/official/home_sign_arrow_down.png" v-else />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="data-trend">
          <div class="tilte-text">近15日订单数据</div>
          <div class="echart-content">
            <div class="echart-dom" style="max-width: 930px" id="chart-line-box">
            </div>
          </div>
        </div>
      </div>
      <withdraw ref="withdraw"></withdraw>
      <realname ref="realname"></realname>
      <!--    新提现页面-->
    </div>
    <withdraw-index ref="withdrawIndex" v-if="!recharge" :official="true"></withdraw-index>
  </div>
</template>

<script>
import {
  getUserUUID,
  getNickname,
  getPlatformUuid,
  getIsBasic,
  getIsAuthOfficial,
  setPlatformUuid,
  setPlatformName,
  setIsBasic,
  setHasPackage,
  setIsAuthOfficial,
  getSnaphotId,
  setSnapshotId,
  setIsOver,
  setHeadImg
} from '@/utils/auth'
import echarts from 'echarts'
import { Modal } from 'view-design'
import Withdraw from '@/components/official/Withdraw.vue'
import Realname from '@/components/official/Realname.vue'
//import { index } from '@/api/promotion'
import home from '@/javaApi/home'


const homeModel = new home()
import official from '@/javaApi/official'

const officialModel = new official()
import withdrawIndex from '@/views/pc/officialWithdraw/index.vue'

export default {
  name: "Wechat",
  components: {
    Withdraw,
    Realname,
    withdrawIndex,
  },
  data: function () {
    return {
      platformUuid: getPlatformUuid(),
      snapshotId: getSnaphotId() || 0,
      chartLine: undefined,
      listLoading: false,
      //isRealName: false,
      activeIndex: 0,
      basicInfo: {
        settleBalance: '0.00',
        effectTime: '',
        name: ''
      },
      statisticsInfo: {
        commissionMonth: '0.00',
        commissionToday: '0.00',
        commissionYesterday: '0.00',
        orderCountMonth: '0',
        orderCountToday: '0',
        orderCountYesterday: '0',
        profitMonth: '0.00',
        profitToday: '0.00',
        profitYesterday: '0.00',
        userCountMonth: '0',
        userCountToday: '0',
        userCountYesterday: '0'
      },
      report: {
        dayList: [],
        orderNumList: [],
      },
      isBasic: getIsBasic() === 'true' ? true : false,
      isAuth: getIsAuthOfficial() === 'true' ? true : false,
      userUUID: getUserUUID(),
      recharge: true,
    }
  },
  computed: {
    increaseUser: function () {
      let increaseUser = this.statisticsInfo.userCountToday - this.statisticsInfo.userCountYesterday
      return parseInt(increaseUser)
    },
    increaseOrder: function () {
      let increaseOrder = this.statisticsInfo.orderCountToday - this.statisticsInfo.orderCountYesterday
      return parseInt(increaseOrder)
    },
    increaseCommission: function () {
      let commission = this.statisticsInfo.commissionToday - this.statisticsInfo.commissionYesterday
      return parseFloat(commission) ? parseFloat(commission) : 0
    },
    increaseProfit: function () {
      let profit = this.statisticsInfo.profitToday - this.statisticsInfo.profitYesterday
      return parseFloat(profit) ? parseFloat(profit) : 0
    }
  },
  created() {
    setTimeout(() => {
      this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 0)
    }, 1)
  },
  mounted: function () {
    this.listLoading = true
    if (parseInt(this.snapshotId) > 0) {
      this.initData();
      this.getPubilcInfo();
    } else {
      this.getPubilcInfo();
    }
  },
  methods: {
    initData() {
      let that = this;
      let param = {}
      if (that.platformUuid != '' && that.platformUuid != 0) {
        param.platformUuid = that.platformUuid
      }
      that.snapshotId = getSnaphotId() || 0
      if (parseInt(that.snapshotId) > 0) {
        param.snapshotId = that.snapshotId
      }

      homeModel.getStatisticsData(param).then((response) => {
        console.log(response);
        var res = response.data
        if (res.code != 200) {
          let messgae = res.message ? res.message : '系统异常请稍后再试'
          that.$Message.error(messgae)
          return
        }
        let condition = (res.data) ? (JSON.stringify(res.data) == "{}") : true
        if (!condition) {
          if (JSON.stringify(res.data.platformStat) != '{}') {
            that.statisticsInfo = res.data.platformStat || {};
          }
          that.report = res.data.stringListMap;
          if (JSON.stringify(res.data.snapshotMap) != '{}') {
            that.basicInfo = res.data.snapshotMap;
            // that.basicInfo.settleBalance = 0
          } else {
            //未开通套餐时，点击任何菜单都是跳转到激活续费页面
            // 弹窗提示 尚未购买任何套餐
            that.$router.push('/pc/official/dialog').catch(err => {
              err
            })
            if (this.isBasic === true) {
              that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 5)
            } else {
              that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 8)
            }
          }
          that.initEchart();
        }
      }).catch(error => {
        console.log(error)
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }

      })
      that.listLoading = false
    },
    initEchart: function () {
      if (!this.report) {
        this.report.dayList = []
        this.report.orderNumList = []
      }
      if (!this.report.dayList) {
        this.report.dayList = []
      }
      if (!this.report.orderNumList) {
        this.report.orderNumList = []
      }

      if (this.report.dayList.length == 0) {
        this.report.dayList = ['暂无数据']
      }

      if (this.report.orderNumList.length == 0) {
        this.report.orderNumList = [0];
      }
      let chartLineBox = document.getElementById('chart-line-box')
      if (!chartLineBox) {
        return
      }
      this.chartLine = echarts.init(document.getElementById('chart-line-box'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: {              //设置tip提示
          trigger: 'axis'
        },
        legend: {               //设置区分（哪条线属于什么）
          data: ['预估订单量']
        },
        color: ['#FF8622'],     //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {                //设置x轴
          type: 'category',
          boundaryGap: false,   //坐标轴两边不留白
          data: this.report.dayList,
          //data: ['2020-12-16', '2020-12-17', '2020-12-18', '2020-12-19', '2020-12-20', '2020-12-21', '2020-12-22', '2020-12-23', '2020-12-24', '2020-12-25', '2020-12-26', '2020-12-27', '2020-12-28', '2020-12-29', '2020-12-30', '2020-12-31'],
          name: '',             //X轴 name
          nameTextStyle: {      //坐标轴名称的文字样式
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {           //坐标轴轴线相关设置。
            lineStyle: {
              color: '#FA6F53',
            }
          }
        },
        yAxis: {
          name: '',
          nameTextStyle: {
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: '#FA6F53',
            }
          },
          type: 'value'
        },
        series: [
          {
            name: '订单量',
            //data: [220, 232, 201, 234, 290, 230, 220, 100, 180, 150, 200, 280, 300, 290, 280],
            data: this.report.orderNumList,
            type: 'line',               // 类型为折线图
            lineStyle: {                // 线条样式 => 必须使用normal属性
              normal: {
                color: '#3D9EFC',
              }
            },
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    getPubilcInfo() {
      officialModel.publicLogin({ openUserUuid: this.userUUID }).then((response) => {
        console.log(response)
        var res = response.data
        if (res.code != 200) {
          setPlatformUuid(0);
          setPlatformName('')
          setSnapshotId(0)
          setIsOver(1)
          setIsBasic(true)
          setHasPackage(false)
          setIsAuthOfficial(false)
          setHeadImg('')
          this.$Message.error(res.message)
          return
        }
        if (res.data.binds.length > 0) {
          var defaultOfficial = res.data.binds[0];
          // 获取当前用户选择的公众号
          let tempSnapshotId = this.snapshotId
          if (tempSnapshotId) {
            let targetSnapshotId = tempSnapshotId
            if (targetSnapshotId == -1) {
              // targetSnapShotId = -1 表示刚刚添加的公众号 买了套餐
              let lastOfficial = res.data.binds.length
              defaultOfficial = res.data.binds[lastOfficial - 1];
            } else {
              let i;
              let tempData;
              for (i = 0; i < res.data.binds.length; i++) {
                tempData = res.data.binds[i]
                if (targetSnapshotId != 0) {
                  if (tempData['snapshotId'] == targetSnapshotId) {
                    defaultOfficial = tempData
                    break;
                  }
                } else {
                  if (tempData['id'] > 0) {
                    defaultOfficial = tempData
                    break;
                  }
                }
              }
            }

          }
          setPlatformUuid(defaultOfficial.platformUuid);
          setPlatformName(defaultOfficial.platformName)
          this.basicInfo.name = defaultOfficial.packageName ? defaultOfficial.packageName : ''
          if (defaultOfficial) {
            // this.basicInfo.effectTime = this.$moment(new Date(defaultOfficial.effectTime)).format('YYYY-MM-DD hh:mm:ss')
            let effectTime = defaultOfficial.effectTime;
            if (effectTime) {
              let date = new Date(effectTime);
              let year = date.getFullYear();
              let month = date.getMonth() + 1;
              let day = date.getDate();
              let hours = date.getHours()
              let min = date.getMinutes()
              let second = date.getSeconds()
              if (month < 10) {
                month = "0" + month;
              }
              if (day < 10) {
                day = "0" + day;
              }
              if (hours < 10) {
                hours = "0" + hours;
              }
              if (min < 10) {
                min = "0" + min;
              }
              if (second < 10) {
                second = "0" + second;
              }
              this.basicInfo.effectTime = year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + second
            }
          }
          if (defaultOfficial.snapshotId !== null) {
            setSnapshotId(defaultOfficial.snapshotId)
          } else {
            setSnapshotId(0)
          }
          setIsOver(defaultOfficial.isOver)
          setHeadImg(defaultOfficial.headImg)
          if (defaultOfficial.isProfit === 1) {
            setIsBasic(false)
          } else {
            setIsBasic(true)
          }
          if (defaultOfficial.packageName !== null) {
            setHasPackage(true)
          } else {
            setHasPackage(false)
          }
          if (defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== '') {
            setIsAuthOfficial(true)
            this.isAuth = true
          } else {
            setIsAuthOfficial(false)
            this.isAuth = false
          }
        }
        this.snapshotId = getSnaphotId() || 0
        if (parseInt(this.snapshotId) > 0) {
          this.initData()
        }
        this.listLoading = false
      }).catch(error => {
        this.listLoading = false
        if (error != 'token invalid') {
          this.$message.error('系统异常请稍后再试！')
        }
      })
    },
    //提现
    withdraw: function () {
      //if(this.isRealName){//已实名
      let settleBalance = 0
      if (this.basicInfo) {
        settleBalance = parseFloat(this.basicInfo.settleBalance)
      }
      settleBalance = settleBalance ? settleBalance : 0
      if (settleBalance <= 0) {
        this.$Message.error('暂无可提现金额')
        return
      }
      this.$refs.withdraw.init(settleBalance)
      //}else{//未实名认证
      //this.$refs.realname.init()
      //}
    },
    //授权
    auth: function () {
      if (this.isBasic === true) {
        this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 4)
      } else {
        this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 7)
      }
      this.$router.push({
        path: '/pc/official/authorization',
      });
    },
    getRequest() {
      var url = location.search; //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    // 是否过期的判断
    getTimeTip() {
      let now = this.$moment()
      let effectTime = this.$moment(this.basicInfo.effectTime)
      let timeDiff = effectTime.diff(now)
      if (timeDiff >= 0) {
        return ''
      }
      return '(已过期)'
    },
    goWithdraw() {
      this.recharge = false
    }
  }
}
</script>

<style scoped>
.margin-left-16 {
  margin-left: 16px;
}

.main-content {
  padding: 0 30px 20px 30px !important;
  min-width: 765px !important;
}

.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .auth-tip-box {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #666666;
  text-align: justify;
  line-height: 40px;
  background: #FFFBE6;
  border-radius: 4px;
  height: 40px;
  padding-left: 10px;
}

.wrapper .auth-tip-box img {
  width: 20px;
}

.wrapper .auth-tip-box .tip-span {
  padding: 0 5px;
}

.wrapper .auth-tip-box .to-auth {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 13px;
  color: #FF4F76;
  cursor: pointer;
  text-decoration: underline;
}

.wrapper .wechat-wrap {
  margin-top: 65px;
}

.wrapper .wechat-wrap .top-part {
  padding: 34px 30px;
  background: #7477D5;
  border: 1px solid #EEEEEE;
  color: #FFFFFF;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  vertical-align: middle;
}

.wrapper .wechat-wrap .top-part .part-title {
  opacity: 0.6;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #FFFFFF;
}

.wrapper .wechat-wrap .top-part .part-content {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 15px;
  color: #FFFFFF;
}

.wrapper .wechat-wrap .top-part .withdraw-box {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 13px;
  text-align: center;
}

.wrapper .wechat-wrap .top-part .withdraw-box .withdraw-btn {
  background: #FFFFFF;
  border-radius: 2px;
  color: #7477D5;
  min-width: 70px;
  padding: 5px 20px;
  display: block;
  cursor: pointer;
}

.wrapper .wechat-wrap .top-part .figure-box {
  margin-top: -91px;
}

.wrapper .wechat-wrap .top-part .figure-box img {
  width: 114px;
}

.wrapper .data-wrap {
  margin-top: 20px;
  color: #666666;
}

.wrapper .data-wrap .data-card {
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  font-size: 13px;
}

.wrapper .data-wrap .data-card .background-eef9ff {
  background: #EEF9FF;
}

.wrapper .data-wrap .data-card .background-fff5ed {
  background: #FFF5ED;
}

.wrapper .data-wrap .data-card .background-ebfbf9 {
  background: #EBFBF9;
}

.wrapper .data-wrap .data-card .background-f5f3fe {
  background: #F5F3FE;
  ;
}

.wrapper .data-wrap .data-card .card-head {
  border-radius: 4px 4px 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  padding: 10px 10px;
}

.wrapper .data-wrap .data-card .card-content {
  padding: 10px 10px;
}

.wrapper .data-wrap .data-card .card-content .card-num {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
  line-height: 38px;
}

.wrapper .data-wrap .data-card .card-content .float-num {
  font-family: Alibaba-PuHuiTi-R;
  color: #FF8622;
}

.wrapper .data-wrap .data-card .card-content .content-desc {
  font-size: 12px;
}

.wrapper .data-wrap .data-card .card-content .content-desc img {
  width: 20px;
}

.wrapper .data-trend {
  margin-top: 30px;
}

.wrapper .echart-content {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  width: 100%;
  margin-top: 0.24rem;
}

.wrapper .echart-dom {
  height: 237px;
  padding: 20px;
}

.wrapper .echart-content .echar-desc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .echart-content .echar-desc .detail-item {
  margin-right: 34px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-badge {
  border-radius: 100%;
  -webkit-box-shadow: 0 0 0 1px #fff;
  box-shadow: 0 0 0 1px #fff;
  width: 8px;
  height: 8px;
  display: inline-block;
  position: relative;
  top: -1px;
  margin-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-title {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  padding-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-content {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.wrapper .echart-content .echart-info {
  padding: 20px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/statistics/Index.vue